import { GlobalStatus, JobTypesEnum, SaleStatusEnum, SoProcessTypesEnum, SoStatusEnum, SoTypesEnum, StatusEnum } from "@gtpl/shared-models/common-models";
import { ApiProperty } from "@nestjs/swagger";
import { BaseEntity, Column, Entity, Index, JoinColumn, JoinTable, ManyToMany, ManyToOne, OneToMany, OneToOne, PrimaryColumn, PrimaryGeneratedColumn, RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('sale_order_log')
export class SaleOrderLog {

  @PrimaryGeneratedColumn("increment", { name: 'sale_order_log_id' })
  saleOrderLogId: number;

  @Column("int", {
    nullable: false,
    name: "sale_order_id"
  })
  saleOrderId: number;

  @Column("varchar", {
    nullable: true,
    length: 250,
    name: "filePath"
  })
  filePath: string;

  @Column("int", {
    nullable: true,
    name: "inspection_id"
  })
  inspectionId: number;

  @Column({
    type: 'enum',
    nullable: false,
    enum: SoStatusEnum,
    default: SoStatusEnum.OPEN,
    name: "status"
  })
  status: string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: GlobalStatus,
    default: GlobalStatus.NO,
    name: "is_invoiced"
  })
  isInvoiced: string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: SoProcessTypesEnum,
    default: SoProcessTypesEnum.MTO,
    name: "so_process_type"
  })
  soProcessType: SoProcessTypesEnum;

  @Column({
    type: 'enum',
    nullable: false,
    enum: SoTypesEnum,
    default: SoTypesEnum.DISPATCH,
    name: "so_type"
  })
  soType: SoTypesEnum;

  @Column("varchar", {
    nullable: false,
    length: 30,
    name: "po_number"
  })
  poNumber: string;

  @Column("varchar", {
    nullable: false,
    length: 30,
    name: "buyer_po_number"
  })
  buyerPoNumber: string;
  
  @Column("datetime", {
    nullable: true,
    name: "stock_reported_date"
  })
  stockreportedDate: Date;

  @Column("date", {
    nullable: true,
    name: "invoice_date"
  })
  invoiceDate: Date;

  @Column("date", {
    nullable: true,
    name: "eda_date"
  })
  edaDate: Date;

  @Column("date", {
    nullable: true,
    name: "act_edl_date"
  })
  actualEdldate: Date;

  @Column("date", {
    nullable: true,
    name: "edl_date"
  })
  edlDate: Date;

  @Column("varchar", {
    nullable: false,
    length: 255,
    name: "cus_address"
  })
  cusAddress: string;

  @Column("varchar", {
    nullable: false,
    length: 250,
    name: "del_address"
    //delivery address
  })
  delAddress: string;

  @Column("int", {
    nullable: false,
    name: "del_terms"
  })
  deliveryTerms: number;

  @Column("int", {
    nullable: false,
    name: "end_customer_id"
  })
  endCustomerId: number;

  @Column("int", {
    nullable: false,
    name: "customer_id"
  })
  customerId: number;

  @Column("int", {
    nullable: false,
    name: "country_id"
  })
  country: number;

  @Column("int", {
    nullable: false,
    name: "destination"
  })
  destination: number;

  @Column("int", {
    nullable: true,
    name: "port_of_entry"
  })
  portOfEntry: number;

  @Column("int", {
    nullable: false,
    name: "pay_terms_id"
  })
  payTermId: number;

  @Column("int", {
    nullable: false,
    name: "shipment_terms"
  })
  shipmentTerms: number;

  @Column("int", {
    nullable: false,
    name: "emp_id"
  })
  salePersonId: number;

  @Column("int", {
    nullable: true,
    name: "currency_id"
  })
  currency: number;

  @Column("int", {
    nullable: true,
    name: "factoryId"
  })
  unit: number;
  @Column({
    type: 'enum',
    nullable: false,
    enum: JobTypesEnum,
    default: JobTypesEnum.MAIN_JOB,
    name: "job_type"
  })
  jobType: JobTypesEnum;
  @Column({
    type: 'enum',
    nullable: false,
    enum: GlobalStatus,
    default: GlobalStatus.NO,
    name: "is_sub_contract"
  })
  isSubContract: GlobalStatus;
  @Column("int", {
    nullable: true,
    name: "processing_unit"
  })
  processingUnit: number;
  //need to remove category column
  @Column("varchar", {
    length:20,
    nullable: true,
    name: "category"
  })
  category: string;

  @Column("int", {
    nullable: true,
    name: "rating"
  })
  rating: number;


  @Column("text", {
    nullable: true,
    name: "additional_note"
  })
  additionalNote: string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: GlobalStatus,
    default: GlobalStatus.NO,
    name: "is_brand_approved"
  })
  isBrandApproved: string;

  

  @Column("varchar",{ 
    nullable:false,
    length:30,
    name:"brandType"
  })
  brandDesignType:string;

  @Column({
    type: 'enum',
    nullable: false,
    enum: GlobalStatus,
    default: GlobalStatus.NO,
    name: "is_certified"
  })
  iscertification: string;

  @Column("varchar",{ 
    nullable:true,
    length:30,
    name:"labInspection"
  })
  labInspection:string;

  @Column("varchar",{ 
    nullable:true,
    length:15,
    name:"lotCode"
  })
  lotCode:string;

  
  @Column("boolean",{ 
    nullable:false,
    default:false,
    name:"laod_inpection"
  })
  loadInspection:boolean;

  @Column("int", {
    nullable: false,
    name: "certification_id"
  })
  certificationId: number;

  @CreateDateColumn({
    name: "created_at",
    type: "datetime"
  })
  createdAt: Date;


}
